import React from 'react';
import { close } from 'components/redux-dialog/fragments/close';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

export const DialogTitle = ({ children, handleClose, hideCloseButton }) => {
  const handleClick = () => {
    if (handleClose) {
      handleClose();
    } else {
      close.notify();
    }
  };

  return (
    <div className="ct-dialog-title">
      <div className="ct-dialog-title__text">{children}</div>
      {!hideCloseButton && (
        <div className="ct-dialog-title__close" data-e2e="dialog-close" onClick={handleClick}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
    </div>
  );
};
